import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Flex } from '@stepstone-genesis/components';
import { HeadingWithText } from './components/HeadingWithText.js';
import { InputWithButton } from './components/InputWithButton.js';
import { AppleUpdateFailedAlert } from './components/AppleUpdateFailedAlert.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { trackModalView } from '../../../../tracking/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../twoStepLoginRegistrationSlice.js';
import { INITIAL_TRACKING_DELAY } from '../../../../constants/tracking.js';
import { authSuccessThunk } from '../../../../core/authSuccess/authSuccessSlice.js';
export const AppleUpdateEmail = () => {
    const dispatch = useAppDispatch();
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            dispatch(sendGlobalTrackingThunk(trackModalView, { componentState }));
        }, INITIAL_TRACKING_DELAY);
        return () => {
            clearTimeout(timeoutId);
            dispatch(authSuccessThunk('apple', null, {
                apple: {
                    skipEmailUpdate: true,
                },
            }));
        };
    }, []);
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceL', "data-testid": "apple-update-email", children: [_jsx(AppleUpdateFailedAlert, {}), _jsxs(Flex, { flxDirection: 'column', gap: ['spaceL', 'spaceL', 'spaceXl'], children: [_jsx(HeadingWithText, {}), _jsx(InputWithButton, {})] })] }));
};
//# sourceMappingURL=AppleUpdateEmail.js.map